// extracted by mini-css-extract-plugin
export default {"BorderlessTextInput":"text-cell-editor-module__BorderlessTextInput--vdwqN","Text":"text-cell-editor-module__Text--dNLHd"};